import React from 'react';

// Toggleable chip group for selecting multiple values from a short fixed list
// (e.g. CBRNE hazard types). value/onChange carry an array of option values.
export default function CheckboxGroup({ label, options = [], value = [], onChange, error }) {
  const toggle = (optionValue) => {
    if (value.includes(optionValue)) onChange(value.filter((v) => v !== optionValue));
    else onChange([...value, optionValue]);
  };

  return (
    <div>
      {label && <label className="form-label">{label}</label>}
      <div className={`flex flex-wrap gap-2 p-1 ${error ? 'ring-1 ring-red-400 rounded-lg' : ''}`}>
        {options.map((option) => {
          const active = value.includes(option.value);
          return (
            <button
              type="button"
              key={option.value}
              onClick={() => toggle(option.value)}
              aria-pressed={active}
              className={`px-3.5 py-2 rounded-full text-sm font-medium border transition-colors ${
                active
                  ? 'bg-seha-500 border-seha-500 text-white'
                  : 'bg-white border-neutral-200 text-neutral-600 hover:border-seha-300 dark:bg-ink-900 dark:border-neutral-700 dark:text-neutral-300'
              }`}
            >
              {option.label}
            </button>
          );
        })}
      </div>
      {error && <p className="text-xs text-red-600 mt-1">{error}</p>}
    </div>
  );
}
